module.exports = __webpack_public_path__ + "static/media/included-appletv-thumbnail.bf6698e4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/included-appletv-thumbnail.jpeg
// module id = 618
// module chunks = 0